/** @file usePuppetRoute: opens the puppet the route names and closes it on the lists or unmount. */
import { useEffect } from 'react';
import type { EditorStore } from '../state/editorTypes';
import { useEditor } from '../state/useEditor';
import { routePuppet } from './routePuppet';

/**
 * A puppet route whose id is not the open puppet opens it (closing the previous one); with `closeOnList` the projects
 * and puppets lists close the open puppet (its socket); Settings keeps it. Unmounting the shell closes the puppet.
 */
export function usePuppetRoute(store: EditorStore, closeOnList: boolean): void {
  const route = useEditor((s) => s.route);
  const signedIn = useEditor((s) => s.session.status === 'signed-in');
  const wanted = routePuppet(route);
  const onList = route.screen === 'projects' || route.screen === 'puppets';
  useEffect(() => {
    if (!signedIn) return;
    const s = store.getState();
    if (wanted !== null && wanted !== s.puppet.id) void s.openPuppet(wanted);
    if (closeOnList && onList && s.puppet.id !== null) s.closePuppet();
  }, [store, wanted, onList, signedIn, closeOnList]);
  useEffect(() => () => { store.getState().closePuppet(); }, [store]);
}
